module.exports = __webpack_public_path__ + "img/KN.7ba1c433.svg";